import { Bilingual } from './protocols';

export interface Soundscape {
  id: string;
  name: Bilingual;
  file: string; // filename under /audio/nature/
}

export const SOUNDSCAPES: Soundscape[] = [
  { id: 'waves', name: { no: 'Bølger', en: 'Waves' }, file: 'waves.mp3' },
  { id: 'rain', name: { no: 'Regn', en: 'Rain' }, file: 'rain.mp3' },
  { id: 'forest', name: { no: 'Skog', en: 'Forest' }, file: 'forest.mp3' },
  { id: 'crickets', name: { no: 'Sirisser', en: 'Crickets' }, file: 'crickets.mp3' },
  { id: 'birdsong', name: { no: 'Fuglesang', en: 'Birdsong' }, file: 'birdsong.mp3' },
  { id: 'plantSong', name: { no: 'Plantesang', en: 'Plant song' }, file: 'plant-song.mp3' },
  // The two Billionaire tracks merged into one continuous file (track 1 then
  // track 2), looped seamlessly by the audio engine.
  { id: 'billionaire', name: { no: 'Billionaire Brainwave', en: 'Billionaire Brainwave' }, file: 'billionaire.mp3' },
];

export function natureUrl(s: Soundscape): string {
  return `/audio/nature/${s.file}`;
}

export type VoiceClip = 'inhale' | 'exhale' | 'hold';

export function voiceUrl(lang: 'no' | 'en', clip: VoiceClip): string {
  return `/audio/voice/${lang}/${clip}.mp3`;
}
